export const scan = {
  modes: {
    single: { title: "Fotografiar un artículo", short: "Un artículo, anuncio listo", description: "Haz una foto y escribiremos el anuncio y sugeriremos un precio." },
    photos: { title: "Fotografiar varios artículos", short: "Hasta 30 fotos", description: "Sube varias fotos y las agruparemos por artículo." },
    video: { title: "Escaneo por vídeo", short: "Graba una habitación", description: "Graba hasta 60 segundos y enumeraremos todo lo que encontremos." },
    deep: { title: "Escaneo profundo", short: "Valoración experta", description: "Analizamos un artículo en profundidad: modelo, estado y precios de venta reales para una valoración más fiable." },
  },
  capture: {
    cameraTitle: "Fotografía tu artículo",
    chooseTitle: "¿Cómo quieres añadir la foto?",
    cameraDescription: "Mantén el artículo dentro del encuadre y pulsa el botón. Puedes hacer varias fotos.",
    chooseDescription: "Usa la cámara del dispositivo, elige un archivo o arrastra las fotos aquí.",
    takeWithCamera: "Hacer una foto con la cámara",
    chooseDevice: "Elegir del dispositivo",
    dropHint: "…o arrastra y suelta las fotos en este recuadro.",
    retry: "Intentar de nuevo",
    chooseComputer: "Elegir fotos del ordenador",
    starting: "Iniciando la cámara…",
    shotAlt: "Foto {{count}}",
    removeShot: "Eliminar foto",
    takeShot: "Hacer foto",
    back: "Volver",
    usePhoto: "Usar esta foto",
    useShots: "Usar {{count}} fotos",
    embeddedError: "El navegador no permite acceder a la cámara aquí. Abre el sitio en una pestaña nueva e inténtalo de nuevo, o elige fotos del ordenador.",
    cameraError: "No pudimos acceder a la cámara. Permite el acceso en el navegador e inténtalo de nuevo, o elige fotos del ordenador.",
    frameError: "La cámara aún no ha generado una imagen. Espera un segundo e inténtalo de nuevo.",
    doneFrameError: "La cámara aún no ha generado una imagen. Pulsa Hacer foto de nuevo dentro de un momento.",
    shotsCounter: "{{count}} de {{max}} fotos",
    limitReached: "Tu plan permite un máximo de {{max}} fotos por anuncio.",
    limitReachedUpgrade: "El plan Gratis permite {{max}} fotos por anuncio. Mejora a Plus para 6 fotos.",
    limitUpgradeLink: "Ver planes y precios",
    clippedBody: "Elegiste {{count}} fotos – solo caben las {{max}} primeras.",
    clippedConfirm: "Continuar con las {{max}} primeras",
    clippedCancel: "Elegir de nuevo",
  },
} as const;
